import React, { useGlobal, useDispatch } from "reactn";
import Styled from "styled-components";
import { HeartTwoTone, LoadingOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { AiFillHeart } from "react-icons/ai";

export const FavoriteButton = ({ desktop, officeId, borderless }) => {
	const createFavorite = useDispatch("createFavorite");
	const deleteFavoriteOffice = useDispatch("deleteFavoriteOffice");
	const [state] = useGlobal();
	const { favorites = {}, user = {} } = state;
	const isFavorite = favorites.offices.includes(officeId);
	const loading = favorites.isLoading;
	const handleClick = () =>
		isFavorite
			? deleteFavoriteOffice({ office_id: officeId })
			: createFavorite({ office_id: officeId });

	return (
		<Tooltip
			title={isFavorite ? "Remover de favoritos" : "Añadir a favoritos"}
			{...(!desktop && { placement: "topRight" })}
		>
			<ButtonWrapper
				isFavorite={isFavorite}
				desktop={desktop}
				borderless={borderless}
			>
				<button onClick={handleClick}>
					{loading && <LoadingOutlined style={{ fontSize: 20 }} />}
					{!loading && (
						<>
							{isFavorite ? (
								<AiFillHeart
									style={{
										color: "#a157b0",
										marginRight: 8,
										fontSize: 16,
									}}
								/>
							) : (
								<HeartTwoTone
									twoToneColor="#1890FF"
									style={{ marginRight: 8 }}
								/>
							)}

							{isFavorite ? "Guardado" : "Guardar"}
						</>
					)}
				</button>
			</ButtonWrapper>
		</Tooltip>
	);
};

const ButtonWrapper = Styled.div`
 width: 100%;
    display: flex;
    justify-content: center;
   
   button {
	   font-family: "Montserrat", sans-serif;
       background-color: transparent;
       /* width: ${(props) => (props.desktop ? "100px" : "70%")}; */
       color: ${(props) =>
			props.isFavorite
				? "#1890FF"
				: props.borderless
				? "#1890FF"
				: "#434343"} ;
        border-radius: 24px;
        height: 28px;
      	border: none;
        display: flex;
        justify-content: center;
        align-items:center;
     
        :hover, :active {
            border:none;
            color:  #1890FF;
            cursor: pointer;
         
        } 
       
   }
`;
